import React from 'react'
import AdForm from '../components/AdForm';
import Header from '../../main/components/Header';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import Path from '../../path/ui/Path';
import { t } from 'i18next';

function Main() {
  return (
    <div>
      <Header />
      <Path currentPath={t('createAnnouncement')} />
      <AdForm />
      <MobileBottomBar activeTabName={'add'} />
    </div>
  )
}

export default Main